import React, { useEffect } from 'react';
import {
  getSearchParams,
  TransformQueryToBoolean,
} from '../../utilities/getSearchParams';
import { useDiagnostico } from '../../context/DiagnosticoContext/DiagnosticoHook';
import ComponentIsEmpty from './ComponentsDiagnosticB/ComponentIsEmpty';
import LoadingSpinner from './ComponentsDiagnosticB/LoadingSpinner';

function WrapperDiagnostic({ children }) {
  const {
    queryFormDiagnosticBFn,
    queryFormDiagnosticBState: { data, isLoading },
  } = useDiagnostico();

  const { id_key } = getSearchParams();
  useEffect(() => {
    if (TransformQueryToBoolean(id_key)) {
      queryFormDiagnosticBFn(id_key).then();
    }
  }, [id_key]);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!data || !data.data || data.data?.isTokenUsed) {
    return <ComponentIsEmpty />;
  }

  return <>{children}</>;
}

export default WrapperDiagnostic;
